import {remCalc} from '../../_utils'

const hideScrollbar = {
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    scrollbarColor: 'transparent transparent',
    '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
        display: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'transparent',
    },
    '& > *::-webkit-scrollbar': {
        width: 0,
        height: 0,
        display: 'none',
    },
}

const highlightedOption = {
    bg: 'background.strong.default',
    color: 'foreground.neutral.inverse',
    borderColor: 'border.neutral.highlight',
    boxShadow:
        'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
}

export default {
    baseStyle: ({colorlessHeaders}: {colorlessHeaders: boolean}) => ({
        productCompareContainer: {
            flexDir: 'column',
            layerStyle: 'full-width',
            width: '100%',
            py: ['small-1.base', 'small-1.sm', 'medium.md', 'medium.lg'],
        },
        headerContainer: {
            justifyContent: 'center',
            marginBottom: ['medium-1.base', 'medium-1.sm', 'medium-1.md', 'medium-1.lg'],
        },
        headerText: {
            textStyle: 'display-small',
            color: 'foreground.neutral.default',
            fontWeight: 'light',
        },
        gridCell: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            whiteSpace: 'normal',
            width: '100%',
            paddingBottom: 'small.base',
            paddingLeft: {
                base: remCalc(8),
                md: remCalc(30),
            },
            paddingRight: {
                base: remCalc(8),
                md: remCalc(30),
            },
            color: 'text.default',
            alignContent: 'flex-start',
        },
        gridHeading: {
            background: {
                base: colorlessHeaders ? '' : 'background.grey',
                lg: '',
            },
            textAlign: {base: 'center', lg: 'left'},
        },
        selectContainer: {
            justifyContent: 'flex-end',
            marginBottom: ['medium-3.base', 'medium-3.sm', 'medium-3.md', 'medium-3.lg'],
        },
        icon: {
            width: remCalc(24),
            height: remCalc(24),
        },
        productsTypo: {
            textAlign: 'center',
            color: 'text.secondary',
            whiteSpace: 'normal',
        },
        productCompareTile: {
            width: {base: '50%', lg: '33.33%'},
            flexDir: 'column',
            maxW: remCalc(450),
            alignItems: 'center',
            color: 'text.default',
        },
        productCompareTileImage: {
            maxW: remCalc(214),
        },
        productNameLabel: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            marginTop: remCalc(14),
            color: 'text.default',
        },
        productIdLabel: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'text.secondary',
            marginTop: remCalc(12),
            marginBottom: remCalc(14),
        },
        productPriceLabel: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'text.default',
        },
        productRetailPriceLabel: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            marginTop: remCalc(12),
            marginBottom: remCalc(14),
        },
        productSpecsContainer: {
            width: {
                base: `calc(100% + ${remCalc(12)})`,
                md: '100%',
            },
            marginRight: {base: remCalc(-12), lg: '0'},
            gap: ['xsmall.base', 'xsmall.sm', 'small.md', 'small.lg'],
            marginBottom: remCalc(34),
            textAlign: 'center',
            justifyContent: {
                base: 'flex-start',
                sm: 'flex-start',
                md: 'space-evenly',
                lg: 'space-evenly',
            },
            flexWrap: {base: 'nowrap', md: 'nowrap', lg: 'nowrap'},
            overflowX: {base: 'auto', sm: 'auto', md: 'hidden', lg: 'hidden'},
            overflowY: 'hidden',
            ...hideScrollbar,
        },
        specsButtonContainer: {
            my: {base: 'medium.base', md: 'medium.md'},
            justifyContent: 'center',
        },
        specsButtonText: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
        },
        specsButton: {
            color: 'button.text.default',
        },
        gridLabel: {
            fontWeight: 'normal',
        },
        grid: {
            w: 'full',
            gap: {base: 'xsmall.base', md: 'small.base', lg: 'small.lg'},
            marginBottom: remCalc(34),
        },
        radioGroupContainer: {
            justifyContent: 'center',
            w: 'full',
            mt: 0,
            marginBottom: ['medium-3.base', 'medium-3.sm', 'medium-3.md', 'medium-3.lg'],
            alignItems: 'center',
            overflowX: {base: 'auto', sm: 'auto', md: 'hidden', lg: 'hidden'},
            overflowY: 'hidden',
            ...hideScrollbar,
        },
        radioGroupShell: {
            display: 'flex',
            flexDirection: 'row',
            w: 'full',
            overflowX: {base: 'auto', sm: 'auto', md: 'hidden', lg: 'hidden'},
            padding: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            justifyContent: {base: 'flex-start', sm: 'flex-start', md: 'center', lg: 'center'},
            alignItems: 'center',
            gap: 0,
            flexWrap: 'nowrap',
            bg: 'background.base.under',
            borderRadius: 'full',
            alignSelf: {base: 'flex-start', sm: 'flex-start', md: 'center', lg: 'center'},
            width: {base: 'max-content', md: 'auto'},
        },
        radioOption: {
            minH: remCalc(28),
            h: remCalc(36),
            minW: 'max-content',
            width: 'auto',
            flex: '0 0 auto',
            alignItems: 'center',
            justifyContent: 'center',
            gap: ['xxxsmall-1.base', 'xxxsmall-1.sm', 'xxxsmall-1.md', 'xxxsmall-1.lg'],
            py: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            px: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'xsmall-1.lg'],
            cursor: 'pointer',
            borderRadius: 'full',
            bg: 'transparent',
            color: 'text.light',
            fontWeight: 'medium',
            textStyle: 'body-small',
            opacity: 1,
            whiteSpace: 'nowrap',
            transition: 'all 0.2s',

            //This is added to avoid the jump in layout when the border appears on hover
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'transparent',

            _hover: {...highlightedOption},

            _focus: {
                boxShadow:
                    'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs) !important',
            },

            _active: highlightedOption,
        },
        radioOptionActive: {
            ...highlightedOption,

            _active: highlightedOption,

            _focus: {
                boxShadow:
                    'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs) !important',
            },
            fontWeight: 'medium',
        },
        radioOptionFirst: {
            borderLeft: 'none',
        },
        radioOptionLast: {
            borderRight: 'none',
        },
        priceContainer: {
            w: 'full',
            direction: 'column',
            align: 'center',
            justify: 'center',
            my: 'small.base',
        },
        priceRow: {
            direction: 'row',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            justify: 'center',
            align: 'flex-start',
            w: 'full',
        },
        priceColumn: {
            direction: 'column',
            align: 'center',
            justify: 'center',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            flex: 1,
        },
        priceLabel: {
            textStyle: 'head-xsmall',
            fontWeight: 'bold',
            textAlign: 'center',
        },
        priceValue: {
            textStyle: 'body-large',
            fontWeight: 'bold',
            textAlign: 'center',
            my: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        priceCardContainer: {
            flexDir: 'column',
            p: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            w: 'full',
            h: remCalc(620),
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        priceValueWrapper: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            w: 'full',
        },
        // single-line row with a fixed height so price/discount/info icons share the same baseline across tiles
        productCardPriceContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            w: 'full',
            height: remCalc(24),
            minHeight: remCalc(24),
            flexShrink: 0,
        },
        cardContentContainer: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'center',
            alignSelf: 'stretch',
            w: 'full',
            gap: remCalc(12),
            pb: {base: 'xsmall.base', lg: 'medium.lg'},
            bg: 'background.base.under',
            borderRadius: 'large-1',
            boxShadow:
                'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            overflow: 'hidden',
        },
        productCard: {
            w: {base: remCalc(170), sm: remCalc(170), md: 'auto', lg: 'auto'},
            minW: {base: remCalc(170), sm: remCalc(170), md: 0, lg: 0},
            flexDir: 'column',
            maxW: remCalc(450),
            alignItems: 'flex-start',
            color: 'text.default',
            gap: ['xsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            flexShrink: {base: 0, sm: 0, md: 1, lg: 1},
            flex: {base: '0 0 auto', sm: '0 0 auto', md: '1 1 0', lg: '1 1 0'},
        },
        // every inner row has a fixed height, so tiles stay aligned regardless of omnibus price/discount visibility
        productCardInfoSection: {
            direction: 'column',
            width: 'full',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: {base: remCalc(6), sm: remCalc(6), md: remCalc(16), lg: remCalc(16)},
            marginBottom: 'small.base',
        },
        titlePriceGroup: {
            direction: 'column',
            width: 'full',
            alignItems: 'flex-start',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        productCardActionContainer: {
            display: 'flex',
            alignItems: 'center',
            height: remCalc(32),
            minHeight: remCalc(32),
            flexShrink: 0,
        },
        productCardName: {
            textStyle: 'body-large',
            fontWeight: 'medium',
            textAlign: 'left',
            color: 'foreground.neutral.default',
            width: 'full',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: remCalc(24),
            minHeight: remCalc(24),
            lineHeight: remCalc(24),
            flexShrink: 0,
        },
        specsProductCardName: {
            textAlign: 'left',
            marginBottom: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        productCardCurrentBadge: {
            display: 'flex',
            height: remCalc(22),
            minHeight: remCalc(22),
            padding: `${remCalc(4)} ${remCalc(8)}`,
            justifyContent: 'center',
            alignItems: 'center',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            flexShrink: 0,
            borderRadius: 'medium-1',
            bg: 'background.base.elevated',
            boxShadow:
                'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 1px 2px 0 var(--chakra-shadows-neutral-xs)',
            backdropFilter: 'blur(calc(var(--sm, 8px) / 2))',
            color: 'foreground.neutral.default',
            leadingTrim: 'both',
            textEdge: 'cap',
            fontVariantNumeric: 'oldstyle-nums tabular-nums',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            lineHeight: 1,
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            textAlign: 'center',
        },
        productCardDetailsIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.muted',
            flexShrink: 0,
        },
        productCardPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            textAlign: 'left',
        },
        cardSwatchContainer: {
            maxWidth: {
                base: 'small-1.base',
                sm: 'small-1.base',
                md: 'unset',
                lg: 'unset',
            },
            height: {base: remCalc(24), sm: remCalc(24), md: 'unset', lg: 'unset'},
            w: 'full',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        productCardColor: {
            textStyle: 'body-small',
            color: 'text.secondary',
            textAlign: 'left',
            h: remCalc(14),
        },
        productCardImageContainer: {
            maxWidth: {
                base: remCalc(120),
                sm: remCalc(120),
                md: 'unset',
                lg: 'unset',
            },
            ratio: 1,
            w: 'full',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        productCardImageBox: {
            w: 'full',
            h: 'full',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        productCardImage: {
            maxW: remCalc(214),
            w: 'full',
            h: 'auto',
        },
        specsCardImage: {
            display: 'flex',
            w: remCalc(64),
            h: remCalc(64),
            mb: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            p: 0,
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: 0,
            aspectRatio: '1/1',
            borderRadius: 'large',
            bg: 'background.base.over',
            boxShadow:
                'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 1px 2px 0 rgba(19, 24, 58, 0.08), 0 0 0 1px rgba(19, 24, 58, 0.08)',
            mixBlendMode: 'multiply',
            filter: 'blur(0px)',
        },
        specsCardContainer: {
            flexDir: 'column',
            pt: {
                base: 'small.base',
                sm: 'small.base',
                md: 'small.base',
                lg: 'small.base',
            },
            pr: {
                base: 'medium-2',
                sm: 'medium-2',
                md: 'medium-2',
                lg: 'medium-2',
            },
            pb: {
                base: 'small.base',
                sm: 'small.base',
                md: 'small.base',
                lg: 'small.base',
            },
            pl: {
                base: 'none',
                sm: 'none',
                md: 'none',
                lg: 'none',
            },
            w: 'full',
            alignItems: 'stretch',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        // CSS grid keeps every column's rows the same height (per-column flex columns can't share row heights)
        specsListContainer: {
            display: 'grid',
            columnGap: ['xsmall.base', 'xsmall.sm', 'small.md', 'small.lg'],
            rowGap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            width: {base: 'max-content', md: '100%', lg: '100%'},
            pt: {base: 'small.base', sm: 'small.base', md: 'small.base', lg: 'small.base'},
            pb: {base: 'small.base', sm: 'small.base', md: 'small.base', lg: 'small.base'},
            marginBottom: remCalc(34),
            overflowX: {base: 'auto', sm: 'auto', md: 'hidden', lg: 'hidden'},
            overflowY: 'hidden',
            ...hideScrollbar,
        },
        specItem: {
            flexDir: 'column',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            pb: 0,
            pr: 'medium-2',
            pl: 'none',
            alignItems: 'flex-start',
        },
        specLabel: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            textAlign: 'left',
        },
        specTitleGroup: {
            flexDir: 'column',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            alignItems: 'flex-start',
        },
        specTitleIcon: {
            boxSize: remCalc(14),
            color: 'foreground.neutral.default',
        },
        specValue: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'foreground.neutral.muted',
            textAlign: 'left',
        },
        tabIcon: {
            boxSize: remCalc(14),
            color: 'currentColor',
        },
        specsTabPanel: {
            flexDir: 'column',
            gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            alignItems: 'flex-start',
            overflowX: {base: 'auto', sm: 'auto', md: 'hidden', lg: 'hidden'},
            overflowY: 'hidden',
            ...hideScrollbar,
        },
        specsRow: {
            display: 'grid',
            columnGap: ['xsmall.base', 'xsmall.sm', 'small.md', 'small.lg'],
            rowGap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            marginBottom: 0,
            width: {base: 'max-content', md: '100%', lg: '100%'},
            overflowX: {base: 'visible', md: 'visible', lg: 'visible'},
            justifyContent: 'flex-start',
            alignItems: 'stretch',
        },
        specsHeaderCard: {
            alignItems: 'flex-start',
            gap: 0,
            width: 'full',
            justifyContent: 'flex-start',
        },
        specsPricingAndActionColumn: {
            direction: 'column',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            alignItems: 'flex-start',
        },
        specsContentCard: {
            alignItems: 'center',
        },
        priceDisplayWrapper: {
            flexDir: 'column',
            alignItems: 'flex-start',
            w: 'full',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        // reserves the omnibus row's height so cards stay aligned whether the omnibus price shows or not
        omnibusPriceSlot: {
            width: 'full',
            maxWidth: '100%',
            minHeight: remCalc(14),
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            overflow: 'hidden',
            '& > *': {
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                flexWrap: {base: 'wrap', sm: 'wrap', md: 'nowrap', lg: 'nowrap'},
                whiteSpace: {base: 'normal', sm: 'normal', md: 'nowrap', lg: 'nowrap'},
                wordBreak: {base: 'break-word', sm: 'break-word', md: 'normal', lg: 'normal'},
                overflowWrap: {
                    base: 'anywhere',
                    sm: 'anywhere',
                    md: 'normal',
                    lg: 'normal',
                },
            },
        },
        listPrice: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'foreground.neutral.subtle',
        },
        currentPrice: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
    }),
}
